import React from 'react';
import { Stack } from '@mui/material';
import { ReportDetailsSection } from '../../components/Sections/DetailsSection';
import { ReportFieldsSection } from '../../components/Sections/FieldsSection';
import { ReportIndividualsSection } from '../../components/Sections/IndividualsSection';
import { ReportUnknownGroupSection } from '../../components/Sections/UnknownGroupSection';
import { ReportDistributionSection } from '../../components/Sections/DistributionSection';
import { ReportRealitiesSection } from '../../components/Sections/RealitiesSection';
import { ActivityStep } from 'modules/activities/types';
import { ReportCustomField } from '../../hooks/useReportCustomFields';
import { ReportOutreachWorkersSection } from 'modules/reports/components/Sections/OutreachWorkersSection';

interface ReportDetailsTabProps {
  display: 'flex' | 'none';
  formDisabled: boolean;
  availableSteps: ActivityStep[];
  activityFields: ReportCustomField[];
  isActivityFieldsFetching: boolean;
  individualFields: ReportCustomField[];
  isIndividualsFieldsFetching: boolean;
  unknownGroupFields: ReportCustomField[];
  isUnknownGroupFieldsFetching: boolean;
  realityFields: ReportCustomField[];
  isRealityFieldsFetching: boolean;
}

export const ReportDetailsTab: React.FC<ReportDetailsTabProps> = ({
  display,
  formDisabled,
  availableSteps,
  activityFields,
  isActivityFieldsFetching,
  individualFields,
  isIndividualsFieldsFetching,
  unknownGroupFields,
  isUnknownGroupFieldsFetching,
  realityFields,
  isRealityFieldsFetching
}) => (
  <Stack display={display} spacing={2}>
    <ReportDetailsSection disabled={formDisabled} />

    <ReportOutreachWorkersSection loading={isActivityFieldsFetching} fields={activityFields} disabled={formDisabled} />

    <ReportFieldsSection loading={isActivityFieldsFetching} fields={activityFields} disabled={formDisabled} />

    {availableSteps.includes('individuals') && (
      <>
        <ReportIndividualsSection
          fields={individualFields}
          loading={isIndividualsFieldsFetching}
          disabled={formDisabled}
        />

        <ReportUnknownGroupSection
          fields={unknownGroupFields}
          loading={isUnknownGroupFieldsFetching}
          disabled={formDisabled}
        />
      </>
    )}

    {availableSteps.includes('distributions') && (
      <ReportDistributionSection disabled={formDisabled} />
    )}

    {availableSteps.includes('realities') && (
      <ReportRealitiesSection
        fields={realityFields}
        loading={isRealityFieldsFetching}
        disabled={formDisabled}
      />
    )}
  </Stack>
);
